import React, { useState, useRef, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { Menu, Dropdown, Avatar } from 'antd';
import * as Icons from 'lucide-react';
import { BookOutlined, DashboardOutlined, HistoryOutlined, ThunderboltOutlined, LogoutOutlined, UserOutlined, CustomerServiceOutlined } from '@ant-design/icons';

const HeaderUserMenu = ({ user, logout }) => {
  const navigate = useNavigate();
  const dropdownRef = useRef(null);

  // Check if user is Master Admin or Admin
  const isMasterAdmin = user?.role === 'master_admin';
  const isAdmin = user?.role === 'admin';
  const isSupport = user?.role === 'support';
  const showDropdown = isMasterAdmin || isAdmin || isSupport;

  // Menu items configuration
  const menuItems = [
    {
      key: 'kb',
      icon: <BookOutlined />,
      label: 'Knowledge Base',
      onClick: () => navigate('/knowledge-base'),
    },
    ...(isMasterAdmin || isAdmin || isSupport ? [{
      key: 'support',
      icon: <CustomerServiceOutlined />,
      label: 'Live Support',
      onClick: () => navigate('/support/dashboard'),
    }] : []),
        ...(isMasterAdmin ? [{
      key: 'status',
      icon: <DashboardOutlined />,
      label: 'System Status',
      onClick: () => navigate('/system/status'),
    }] : []),
    {
      key: 'changelog',
      icon: <HistoryOutlined />,
      label: 'Platform Changelog',
      onClick: () => navigate('/changelog'),
    },
    {
      key: 'shortcuts',
      icon: <ThunderboltOutlined />,
      label: 'Keyboard Shortcuts',
      onClick: () => navigate('/shortcuts'),
    },
    {
      type: 'divider',
    },
    {
      key: 'logout',
      icon: <LogoutOutlined />,
      label: 'Logout',
      onClick: logout,
    },
  ];

  // For non-Master Admin and non-Admin users, show static display (no dropdown)
  if (!showDropdown) {
    return (
      <div className="flex items-center gap-2 sm:gap-3 pl-2 sm:pl-3" style={{ borderLeft: '1px solid rgba(99, 102, 241, 0.1)' }}>
        <div className="hidden sm:block text-right">
          <p className="text-sm font-semibold text-gray-800">
            {user?.full_name || user?.username}
          </p>
          <p className="text-[10px] font-medium text-gray-400">@{user?.username} <span className="uppercase tracking-wider" style={{ color: '#6366f1' }}>{user?.role?.replace('_', ' ')}</span></p>
        </div>
        <div className="relative">
          <div className="rounded-xl flex items-center justify-center text-white font-bold text-sm shadow-md" style={{
            width: '38px', height: '38px',
            background: 'linear-gradient(135deg, #4f46e5 0%, #06b6d4 100%)',
          }}>
            {user?.full_name?.[0] || user?.username?.[0]?.toUpperCase() || 'U'}
          </div>
          <div className="absolute -bottom-0.5 -right-0.5 w-3 h-3 bg-emerald-400 border-2 border-white rounded-full" />
        </div>
      </div>
    );
  }

  // For Master Admin and Admin users, show dropdown
  return (
    <div className="flex items-center gap-2 sm:gap-3 pl-2 sm:pl-3" style={{ borderLeft: '1px solid rgba(99, 102, 241, 0.1)' }}>
      <div className="hidden sm:block text-right">
        <p className="text-sm font-semibold text-gray-800">
          {user?.full_name || user?.username}
        </p>
        <p className="text-[10px] font-medium text-gray-400">@{user?.username} <span className="uppercase tracking-wider" style={{ color: '#6366f1' }}>{user?.role?.replace('_', ' ')}</span></p>
      </div>
      
      <Dropdown 
        menu={{ items: menuItems }}
        trigger={['click']}
        placement="bottomRight"
        popupRender={(menu) => (
          <div style={{ minWidth: '200px' }}>
            {menu}
          </div>
        )}
      >
        <div className="relative cursor-pointer">
          <div className="rounded-xl flex items-center justify-center text-white font-bold text-sm shadow-md transition-all duration-200 hover:shadow-lg hover:scale-105" style={{
            width: '38px', height: '38px',
            background: 'linear-gradient(135deg, #4f46e5 0%, #06b6d4 100%)',
          }}>
            {user?.full_name?.[0] || user?.username?.[0]?.toUpperCase() || 'U'}
          </div>
          <div className="absolute -bottom-0.5 -right-0.5 w-3 h-3 bg-emerald-400 border-2 border-white rounded-full" />
        </div>
      </Dropdown>
    </div>
  );
};

export default HeaderUserMenu;
